import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { homeGuard } from './shared/guards/home.guard';
import { loginGuard } from './shared/guards/login.guard';
import { devOnlyGuard } from './shared/guards/dev-only.guard';

export const routes: Routes = [
  {
    path: 'dev/receipt-preview',
    canActivate: [devOnlyGuard],
    loadComponent: () => import('./pages/dev/receipt-preview/receipt-preview.component').then(m => m.ReceiptPreviewComponent),
  },
  {
    path: 'login',
    canActivate: [loginGuard],
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'forgot-password',
    canActivate: [loginGuard],
    loadComponent: () => import('./pages/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent),
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./pages/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
  },
  // ── Órdenes de compra (público) ──────────────────────────────────────────
  {
    path: 'orden/iniciar',
    loadComponent: () => import('./pages/orden/iniciar/iniciar-orden.component').then(m => m.IniciarOrdenComponent),
  },
  {
    path: 'orden/completar',
    loadComponent: () => import('./pages/orden/completar/completar-orden.component').then(m => m.CompletarOrdenComponent),
  },
  {
    path: 'orden/resultado',
    loadComponent: () => import('./pages/orden/resultado/resultado-orden.component').then(m => m.ResultadoOrdenComponent),
  },
  {
    path: 'invite',
    loadComponent: () => import('./pages/invite/invite.component').then(m => m.InviteComponent),
  },
  // ── App principal (requiere login) ─────────────────────────────────────
  {
    path: '',
    component: LayoutComponent,
    canActivate: [homeGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent),
      },
      {
        path: 'productos',
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () => import('./pages/productos/productos.component').then(m => m.ProductosComponent),
          },
          {
            path: 'nuevo',
            loadComponent: () => import('./pages/productos/producto-form/producto-form.component').then(m => m.ProductoFormComponent),
          },
          {
            path: ':id',
            loadComponent: () => import('./pages/productos/producto-detalle/producto-detalle.component').then(m => m.ProductoDetalleComponent),
          },
          {
            path: ':id/editar',
            loadComponent: () => import('./pages/productos/producto-form/producto-form.component').then(m => m.ProductoFormComponent),
          },
        ],
      },
      {
        path: 'categorias',
        loadComponent: () => import('./pages/categorias/categorias.component').then(m => m.CategoriasComponent),
      },
      {
        path: 'pedidos',
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () => import('./pages/pedidos/pedidos.component').then(m => m.PedidosComponent),
          },
          {
            path: ':id',
            loadComponent: () => import('./pages/pedidos/pedido-detalle/pedido-detalle.component').then(m => m.PedidoDetalleComponent),
          },
        ],
      },
      {
        path: 'clientes',
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () => import('./pages/clientes/clientes.component').then(m => m.ClientesComponent),
          },
          {
            path: ':id',
            loadComponent: () => import('./pages/clientes/cliente-detalle/cliente-detalle.component').then(m => m.ClienteDetalleComponent),
          },
        ],
      },
      {
        path: 'balances',
        loadComponent: () => import('./pages/balances/balances.component').then(m => m.BalancesComponent),
      },
      {
        path: 'costos-envio',
        loadComponent: () => import('./pages/costos-envio/costos-envio.component').then(m => m.CostosEnvioComponent),
      },
      {
        path: 'descuentos',
        loadComponent: () => import('./pages/descuentos/descuentos.component').then(m => m.DescuentosComponent),
      },
      {
        path: 'qr-dinamicos',
        loadComponent: () => import('./pages/qr-dinamicos/qr-dinamicos.component').then(m => m.QrDinamicosComponent),
      },
      {
        path: 'formularios',
        loadComponent: () => import('./pages/formularios/formularios.component').then(m => m.FormulariosComponent),
      },
      // ── WEBLY-WEB — Plantillas y páginas ─────────────────────────────────
      {
        path: 'plantillas-web',
        loadComponent: () => import('./pages/plantillas-web/plantillas-web.component').then(m => m.PlantillasWebComponent),
      },
      {
        path: 'paginas-web',
        loadComponent: () => import('./pages/paginas-web/paginas-web.component').then(m => m.PaginasWebComponent),
      },
      {
        path: 'mi-cuenta',
        loadComponent: () => import('./pages/mi-cuenta/mi-cuenta.component').then(m => m.MiCuentaComponent),
      },
      {
        path: 'organizaciones',
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () => import('./pages/organizaciones/organizaciones.component').then(m => m.OrganizacionesComponent),
          },
          {
            path: ':id',
            loadComponent: () => import('./pages/organizaciones/org-detalle/org-detalle.component').then(m => m.OrgDetalleComponent),
          },
        ],
      },
      {
        path: 'equipo',
        loadComponent: () => import('./pages/equipo/equipo.component').then(m => m.EquipoComponent),
      },
      {
        path: 'mi-organizacion',
        loadComponent: () => import('./pages/mi-organizacion/mi-organizacion.component').then(m => m.MiOrganizacionComponent),
      },
      {
        path: 'suscripcion',
        loadComponent: () => import('./pages/suscripcion/suscripcion.component').then(m => m.SuscripcionComponent),
      },
      {
        path: 'datos-fiscales',
        loadComponent: () => import('./pages/datos-fiscales/datos-fiscales.component').then(m => m.DatosFiscalesComponent),
      },
      {
        path: 'actividad',
        loadComponent: () => import('./pages/actividad/actividad.component').then(m => m.ActividadComponent),
      },
      {
        path: 'checkout/success',
        loadComponent: () => import('./pages/checkout-success/checkout-success.component').then(m => m.CheckoutSuccessComponent),
      },
      {
        path: 'checkout/cancel',
        loadComponent: () => import('./pages/checkout-cancel/checkout-cancel.component').then(m => m.CheckoutCancelComponent),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
